import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

// Число у пункта меню (например, задачи, которые ждут): справа в строке пункта, в свёрнутом
// меню — маленьким кружком в углу значка. Стоит рядом с `SidebarMenuButton` внутри
// `SidebarMenuItem` и на нажатия не реагирует: нажимается сам пункт.
export const SidebarMenuBadge = ({ className, ...props }: ComponentProps<"span">) => (
  <span
    data-slot="sidebar-menu-badge"
    className={cn(
      "pointer-events-none absolute top-1/2 right-2.5 inline-flex h-5.5 min-w-5.5 -translate-y-1/2 items-center justify-center rounded-full bg-accent px-1.5 font-mono text-xs font-semibold text-accent-foreground group-data-[state=collapsed]/sidebar:top-1 group-data-[state=collapsed]/sidebar:right-1 group-data-[state=collapsed]/sidebar:h-4 group-data-[state=collapsed]/sidebar:min-w-4 group-data-[state=collapsed]/sidebar:translate-y-0 group-data-[state=collapsed]/sidebar:px-1 group-data-[state=collapsed]/sidebar:text-[10px]",
      className,
    )}
    {...props}
  />
);
